import { PAGES } from "../constants";

export const ALL_CLASSES = `${PAGES} [AllClasses]`;
export const CLASS_FORM = `${PAGES} [ClassForm]`;

export const START_ALL_CLASSES_SCREEN = `${ALL_CLASSES} START`;
export const START_NEW_CLASS_SCREEN = `${CLASS_FORM} START_NEW_CLASS_SCREEN`;
export const SAVE_CLASS = `${CLASS_FORM} SAVE_CLASS`;

export const startAllClassesScreen = ({ organizationId, subOrganizationId } = {}) => ({
  type: START_ALL_CLASSES_SCREEN,
  payload: { organizationId, subOrganizationId },
});

export const startNewClassScreen = () => ({
  type: START_NEW_CLASS_SCREEN,
});

export const saveClass = ({ classes }) => ({
  type: SAVE_CLASS,
  payload: { classes },
});
